<bci-wk-modal id="modal-redirect" class="modal">
  <div class="container-modal">
    <img
      class="war wk-padding-bottom-24"
      src="./assets/images/icon-modal-redirect.png"
      alt="waricon"
    />
    <bci-wk-modal-title bciWkTypeH1000
      >Puedes resolver esta consulta en Hazlo en Línea
    </bci-wk-modal-title>

    <p class="resume">
      Te mostramos cómo lo puedes hacer con nuestras guías paso a paso.
    </p>

    <bci-wk-modal-actions>
      <button bciWkButtonSecondary (click)="goToSchedule()">
        Prefiero ir a sucursal
      </button>
      <button bciWkButtonPrimary (click)="goToRedirect()">
        Ir a Hazlo en Línea
      </button>
    </bci-wk-modal-actions>
  </div>
</bci-wk-modal>
